import { render, staticRenderFns } from "./cModalDev.vue?vue&type=template&id=50a5155c&scoped=true"
import script from "./cModalDev.vue?vue&type=script&lang=js"
export * from "./cModalDev.vue?vue&type=script&lang=js"
import style0 from "./cModalDev.vue?vue&type=style&index=0&id=50a5155c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5155c",
  null
  
)

export default component.exports